export default __webpack_public_path__ + "static/media/gallery_15.25f552f1.jpg";